
function snipMe() {

    $(document).ready(function() {


      $("table.hello2").each(function(i,v){
        if(!$(this).find("tbody").html()){
            $(this).hide()
        }
     })
     
        $('.A4').each(function() {
          snipMeA4.call(this);
        });

           //----newly added-----
           $('.A5').each(function() {
            snipMeA5.call(this);
          });

          // //----newly added-----
          // $('.btnA5').each(function(i) {
          //   $(this).val(i+1);
          //   });
          //   //----newly added-----
            
      //----newly added-----



      });


}

